import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'
import type { MembershipModel } from '@/modules/auth/use-cases'
import { Button } from '@/shared/ui/primitives'

export type AlreadyClaimedStateProps = {
  orgName: string
  role: string
  membershipModel?: MembershipModel
}

export function AlreadyClaimedState({ orgName, role, membershipModel }: AlreadyClaimedStateProps) {
  const isProCrew = membershipModel === 'pro'
  const heading = isProCrew
    ? orgName
      ? `You're already a member of the crew ${orgName}.`
      : 'Invitation already accepted.'
    : orgName && role
      ? `You're already a ${role} of ${orgName}.`
      : 'Invitation already accepted.'
  const body = isProCrew
    ? 'Your crew invitation has already been accepted. Open the BlindBook app to see your crew.'
    : 'Your invitation has already been accepted. Sign in to continue to your dashboard.'

  return (
    <AuthLayout title="Invitation already accepted" subtitle={heading}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-sage-soft">
            <CheckCircle2 className="h-8 w-8 text-sage" aria-hidden />
          </div>
        </div>
        <p className="text-sm text-muted-foreground">{body}</p>
        <Button asChild variant="default" className="w-full">
          <Link to="/sign-in">Continue to sign in</Link>
        </Button>
      </div>
    </AuthLayout>
  )
}
